import { Check } from "lucide-react";

const RATE_TIERS = [
  {
    tier: "City Feature",
    price: "$2,500",
    cadence: "per city",
    tag: "Starter",
    accent: "#FFFFFF",
    perfect: "Local brands · launches · single-stop activations",
    includes: [
      "Branded post in the live feed (geo-pinned)",
      "1 reel + 3-story IG set, 1 TikTok",
      "Mention on live stream + dispatch email",
      "Logo in city stop on the live route map",
    ],
  },
  {
    tier: "Drop Collab",
    price: "$7,500",
    cadence: "per drop",
    tag: "Most popular",
    accent: "#FF1493",
    featured: true,
    perfect: "DTC brands · product launches · co-branded merch",
    includes: [
      "Co-branded 48h limited drop (your logo on the SKU)",
      "Site-wide drop banner + countdown timer",
      "Dedicated launch email to full audience",
      "All-platform announcement (IG + TikTok + YouTube)",
      "Revenue split on units sold",
    ],
  },
  {
    tier: "Series Sponsor",
    price: "$25,000+",
    cadence: "per leg",
    tag: "Presenting partner",
    accent: "#FFC107",
    perfect: "National brands · category exclusivity · multi-city",
    includes: [
      "Presenting partner status (logo on nav + footer + map)",
      "5+ city features bundled",
      "1 Drop Collab included",
      "Dedicated IRL meetup with branded experience",
      "Tour Pass + AI chat cross-promo",
      "Category exclusivity for the leg",
    ],
  },
];

export default function RateCard({ onSelectTier }) {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-8 py-16" data-testid="rate-card">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
        <div>
          <div className="overline">Rate card · 2026</div>
          <h2 className="font-display text-4xl md:text-5xl uppercase mt-3 drip-shadow">
            Pick your plug-in
          </h2>
        </div>
        <div className="text-xs font-mono-tactical text-white/50 uppercase tracking-[0.25em] max-w-md text-right">
          Self-qualify in 30 seconds · Custom packages on request
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {RATE_TIERS.map((p) => (
          <article
            key={p.tier}
            className={`tac-card p-7 flex flex-col relative ${
              p.featured ? "border-[#FF1493]/60" : ""
            }`}
            style={p.featured ? { boxShadow: "0 0 0 1px #FF1493 inset" } : {}}
            data-testid={`rate-${p.tier.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="flex items-center justify-between">
              <span className="overline" style={{ color: p.accent }}>
                {p.tag}
              </span>
              {p.featured && (
                <span className="bg-[#FF1493] text-white px-2 py-1 text-[10px] font-bold uppercase tracking-[0.2em]">
                  Hot
                </span>
              )}
            </div>
            <h3 className="font-display text-3xl uppercase mt-4">{p.tier}</h3>
            <div className="mt-3 flex items-end gap-2">
              <span className="font-display text-5xl leading-none" style={{ color: p.accent }}>
                {p.price}
              </span>
              <span className="text-white/60 text-sm mb-1">{p.cadence}</span>
            </div>
            <p className="text-white/65 text-xs mt-3 italic">Perfect for: {p.perfect}</p>

            <ul className="mt-5 space-y-2 text-sm flex-1">
              {p.includes.map((inc) => (
                <li key={inc} className="flex items-start gap-2 text-white/80">
                  <Check size={14} className="text-[#FF1493] shrink-0 mt-0.5" />
                  <span>{inc}</span>
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              className={p.featured ? "btn-blaze mt-6 justify-center" : "btn-ghost mt-6 justify-center"}
              onClick={() => onSelectTier(p.tier)}
              data-testid={`rate-cta-${p.tier.toLowerCase().replace(/\s+/g, "-")}`}
            >
              Start with {p.tier}
            </a>
          </article>
        ))}
      </div>

      <div className="mt-6 text-xs font-mono-tactical text-white/50 uppercase tracking-[0.2em] flex flex-wrap gap-x-6 gap-y-2">
        <span>★ Net-30 invoicing</span>
        <span>★ Performance reports included</span>
        <span>★ Custom packages: ask</span>
      </div>
    </section>
  );
}
